<template lang="pug">
  div.normative
    e-toolbar(
    :items="items"
    :hideRemoveButton="true"
    :showTotal="true"
    :showViewPanel="false"
    :hideImportBtn="true"

    :useFilterBtn="true"
    :showFilter="showFilter"
    @closeFilterPanel="onCloseFilterPanel()"
    @openFilterPanel="onOpenFilterPanel()"
    )
      e-form-search-filter(
      slot="filter"
      :formValidator="formValidator"
      v-if="showFilter"
      @apply="applyFilter()"
      @reset="resetFilter()"
      )
        div.one-row
          e-form-group(
          formGroupStyle="filter-block"
          label="Дата начала действия"
          inputType="calendar-range"
          :model="filterModel"
          tabView="tab1"
          name="start_date_from"
          toName="start_date_to"
          )

          e-form-group(
          formGroupStyle="filter-block"
          label="Дата окончания действия"
          inputType="calendar-range"
          :model="filterModel"
          tabView="tab1"
          name="end_date_from"
          toName="end_date_to"
          )

          e-form-search-filter-buttons(
          :loading="searchInProgress"
          ).filter-block

    e-table(
    :items="items"
    :showCheckbox="false"
    :defaultColumnWidth="150"
    :showDownloadButton="true"
    @download="onDownload"
    @editItem="editItem"
    :showDeleteButton="false"
    :actionColumnWidth="75"
    )

    router-view
</template>

<script>
  import {billing} from '../../api/api-endpoints.js'
  import normativeTableMixin from "./mixins/normative-table"
  import {NORMATIVE_TYPE_LEGAL} from "../../config/config"

  export default {
    mixins: [normativeTableMixin],
    methods: {
      getDownloadEndpoint () {
        return billing.normativesDownload(NORMATIVE_TYPE_LEGAL)
      },
      getEndpoint (route) {
        return billing.normativeBranchs(route, NORMATIVE_TYPE_LEGAL)
      },
      getDeleteUrl (id) {
        return billing.normativeClose(id)
      }
    }
  }
</script>
